(function () {
  const initSlider = (section) => {
    if (!section) return;
    const slider = section.querySelector('.text-slider__swiper');
    if (!slider) return;
    if (typeof Swiper === 'undefined') return;

    const prevBtn = section.querySelector('.cards-grid__navigation-button-prev');
    const nextBtn = section.querySelector('.cards-grid__navigation-button-next');
    const pagination = section.querySelector('.text-slider__pagination');

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      speed: 800,
      autoHeight: true,
      mousewheel: {
        forceToAxis: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        paginationBulletMessage: 'Go to slide {{index}}',
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: 'swiper-button-disabled',
      },
      pagination: pagination
        ? {
            el: pagination,
            clickable: true,
            bulletElement: 'button',
          }
        : false,
    });
  };

  initSlider(document.currentScript.parentElement);

  document.addEventListener('shopify:section:load', function (event) {
    initSlider(event.target);
  });
})();
